import { render, staticRenderFns } from "./shudicenterBottom.vue?vue&type=template&id=74273aa7&scoped=true"
import script from "./shudicenterBottom.vue?vue&type=script&lang=js"
export * from "./shudicenterBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74273aa7",
  null
  
)

export default component.exports